<ng-container *ngComponentOutlet="LoaderComponent">
</ng-container>
<div mat-dialog-title style="position: relative;" *ngIf="pageID === 1">
    <p class="dialog-title text-center" *ngIf="countryArrayEditView.CountryName === 'India'"  >
        <span>Call Reason</span>
    </p>
    <p class="dialog-title text-center" *ngIf="countryArrayEditView.CountryName !== 'India'"  >
        <span>Click to Call</span>
    </p>
    <button type="button" (click)="onNoClick()" class="close" data-dismiss="modal" aria-label="Close"
        style="color: black; top: 0px;left: 420px;position: absolute;">
        <span aria-hidden="true" class="">&times;</span>
    </button>
</div>
<div mat-dialog-content class="dialog-content" *ngIf="pageID === 1 && makeCallAccess === 1">
    <form [formGroup]="callReasonForm" (ngSubmit)="initiateClickToCall()" *ngIf="!isCallInitiated">
        <!-- <div>
            <span style="color: red;"> Call Reason* </span>
        </div> -->
        <div class="row mb-3" style="justify-content: center; display: flex;" >

          
            <select id="name" class="form-select ka-dropdown-singleSelect col-7" formControlName="callReason" aria-label="Default select example">
                <option  class="select-option" [ngValue]="null">Select Reason to Make call</option>
                <option class="select-option" *ngFor="let reason of callReasonArray" [ngValue]="reason">{{reason.value}}</option>   
            </select>


        </div>
        <div class="row mb-1" style="justify-content: center; display: flex;">
                <span *ngIf="contactName !== '' || contactName !== null">Calling {{contactName}} ...</span>
        </div>

        <div class="row" style="justify-content: center; display: flex;" >
            <button [disabled]="callReasonForm.invalid"  class="btn m-2 ka-myProfile-viewType" mdbWavesEffect type="submit"> Call </button>
            <button type="button" (click)="onNoClick()" class=" m-2 reset-btn">Cancel</button>  
        </div>
        <!-- <div class="row" style="justify-content: center; display: flex;" *ngIf="countryArrayEditView.CountryName !== 'India'">
            <div class="col-12 text-center text-danger">
                <strong class="text-danger">Click to call for Foreign Numbers is not Enabled</strong>
               </div> 
        </div> -->
        <div class="row" *ngIf="countryArrayEditView.CountryName !== 'India'">
            <span class="col-12 text-center" style="color: red;">* You are trying to call a {{countryArrayEditView.CountryName}} number with country code {{countryArrayEditView.CountryCode}}</span> 
         </div>


    </form>
    <div class="row d-flex justify-content-center" *ngIf="isCallInitiated">
       <div>
        <strong class="text-success">{{callResponseMessage}}</strong>
       </div> 
    </div>
    <div class="row mt-2 d-flex justify-content-center" *ngIf="isCallInitiated">
        <div>
         <strong class="text-success">{{callResponseMessage1}}</strong>
        </div> 
     </div>
    

</div>
<div *ngIf="pageID === 1 && makeCallAccess === 0">    
<div class="ka-noCallAccess">Please contact RM <br> {{profileOwner}}</div>
</div>

<div mat-dialog-title style="position: relative;" *ngIf="pageID === 2">
    <p class="dialog-title text-center"   >
        <span>Make a Call</span>
    </p>
    <button type="button" (click)="onNoClick()" class="close" data-dismiss="modal" aria-label="Close"
        style="color: black; top: 0px;left: 420px;position: absolute;">
        <span aria-hidden="true" class="">&times;</span>
    </button>
</div>
<div mat-dialog-content class="dialog-content" *ngIf="pageID === 2 && makeCallAccess === 1">
    <form [formGroup]="callRelationForm" (ngSubmit)="initiateClickToCallInMFU()" *ngIf="!isCallInitiatedMFU">
        <div *ngIf="!isTypeSelected">
            <div class="text-center mb-4"> Please Select Type of Call</div>
            <div class="text-center">
            <button  class=" m-2 ka-myProfile-viewType" (click)="typeOfCall(false)"  mdbWavesEffect type="submit">Customer Call</button>      
            <button   class=" m-2 ka-myProfile-viewType" (click)="typeOfCall(true)"  mdbWavesEffect type="submit">Conference Call</button>                  
        </div>
        </div>
        <div class="row mb-3" style="justify-content: center; display: flex;" *ngIf="isTypeSelected">

        
            <select id="name" class="form-select ka-dropdown-singleSelect col-7" (change)="selectCustomerRelationFollowUp()" formControlName="callRelation" aria-label="Default select example">
                <option  class="select-option" [ngValue]="null">Select Relation to Make call</option>
                <option class="select-option" *ngFor="let relation of contactRelationArray" [ngValue]="relation">{{relation.value}}</option>   
            </select>


        </div>
        <div class="row mb-1" style="justify-content: center; display: flex;" *ngIf="isRelation">
                <span *ngIf="contactNameMatchFollowUp !== '' || contactNameMatchFollowUp !== null">Calling {{contactNameMatchFollowUp}} <span *ngIf="contactNumber !== '' || contactNumber !== null">{{contactNumber}}</span> ...</span>
        </div>

        <div class="row" style="justify-content: center; display: flex;" *ngIf="isRelation">
            <button [disabled]="callRelationForm.invalid"  class="btn m-2 ka-myProfile-viewType" mdbWavesEffect type="submit"> Call </button>
            <button type="button" (click)="onNoClick()" class=" m-2 reset-btn">Cancel</button>  
        </div>
        <div class="row" *ngIf="isRelation && countryArray.CountryName !== 'India'">
           <span class="col-12 text-center" style="color: red;">* You are calling a {{countryArray.CountryName}} number with country code {{countryArray.CountryCode}}</span> 
        </div>
        <!-- <div class="row" style="justify-content: center; display: flex;" *ngIf="isRelation && countryArray.CountryName !== 'India'">
            <div class="col-12 text-center text-danger">
                <strong class="text-danger">Click to call for Foreign Numbers is not Enabled</strong>
               </div> 
        </div> -->
 

    </form>
    <div class="row d-flex justify-content-center" *ngIf="isCallInitiatedMFU">
        <div>
         <strong class="text-success">{{callResponseMessage}}</strong>
        </div> 
     </div>
     <div class="row mt-2 d-flex justify-content-center" *ngIf="isCallInitiatedMFU">
         <div>
          <strong class="text-success">{{callResponseMessage1}}</strong>
         </div> 
      </div>
</div>
<div mat-dialog-content class="dialog-content" *ngIf="pageID === 2 && makeCallAccess === 0">    
    <div class="ka-noCallAccess">Please contact RM  <br> {{profileOwner}}</div>
    </div>

<div mat-dialog-title style="position: relative;" *ngIf="pageID === 3">
    <p class="dialog-title text-center"   >
        <span>Make a Call</span>
    </p>
    <button type="button" (click)="onNoClick()" class="close" data-dismiss="modal" aria-label="Close"
        style="color: black; top: 0px;left: 420px;position: absolute;">
        <span aria-hidden="true" class="">&times;</span>
    </button>
</div>
<div mat-dialog-content class="dialog-content" *ngIf="pageID === 3 && makeCallAccess === 1">
    <form [formGroup]="callRelationForm" (ngSubmit)="initiateClickToCallInMarketing()" *ngIf="!isCallInitiatedMarketing">
        <!-- <div>
            <span style="color: red;"> Call Reason* </span>
        </div> -->
        <div class="row mb-3" style="justify-content: center; display: flex;">

          
            <select id="name" class="form-select ka-dropdown-singleSelect col-7" (change)="selectCustomerRelationMarketing()" formControlName="callRelation" aria-label="Default select example">
                <option  class="select-option" [ngValue]="null">Select Relation to Make call</option>
                <option class="select-option" *ngFor="let relation of contactRelationArray" [ngValue]="relation">{{relation.value}}</option>   
            </select>


        </div>
        <div class="row mb-1" style="justify-content: center; display: flex;" *ngIf="isRelation">
                <span *ngIf="contactNameMatchFollowUp !== '' || contactNameMatchFollowUp !== null">Calling {{contactNameMarketing}} <span *ngIf="contactNumberMarketing !== '' || contactNumberMarketing !== null">{{contactNumberMarketing}}</span>...</span>
        </div>

        <div class="row" style="justify-content: center; display: flex;" *ngIf="isRelation">
            <button [disabled]="callRelationForm.invalid"  class="btn m-2 ka-myProfile-viewType" mdbWavesEffect type="submit"> Call </button>
            <button type="button" (click)="onNoClick()" class=" m-2 reset-btn">Cancel</button>  
        </div>
        <div class="row" *ngIf="isRelation && countryArrayMarketing.CountryName !== 'India'">
            <span class="col-12 text-center" style="color: red;">* You are calling a {{countryArrayMarketing.CountryName}} number with country code {{countryArrayMarketing.CountryCode}}</span> 
         </div>
         <!-- <div class="row" style="justify-content: center; display: flex;" *ngIf="isRelation && countryArrayMarketing.CountryName !== 'India'">
            <div class="col-12 text-center text-danger">
                <strong class="text-danger">Click to call for Foreign Numbers is not Enabled</strong>
               </div> 
        </div> -->


    </form>
    <div class="row d-flex justify-content-center" *ngIf="isCallInitiatedMarketing">
        <div >
         <strong class="text-success">{{callResponseMessage}}</strong>
        </div> 
     </div>
     <div class="row mt-2 d-flex justify-content-center" *ngIf="isCallInitiatedMarketing">
         <div >
          <strong class="text-success">{{callResponseMessage1}}</strong>
         </div> 
      </div>
</div>
<div mat-dialog-content class="dialog-content" *ngIf="pageID === 3 && makeCallAccess === 0">    
    <div class="ka-noCallAccess">Please contact RM <br> {{profileOwner}}</div>
    </div>

<!-- <div mat-dialog-title style="position: relative;" *ngIf="logID === 1">
    <p class="dialog-title text-center"   >
        <span>Call Recording</span>
    </p>
    <button type="button" (click)="onNoClick()" class="close" data-dismiss="modal" aria-label="Close"
        style="color: black; top: 0px;left: 420px;position: absolute;">
        <span aria-hidden="true" class="">&times;</span>
    </button>
</div> -->

